function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP App
 *
 *
 */
import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Cookies from './components/cookies/Cookies';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import ErrorBoundary from './components/error-boundary/ErrorBoundary';
import Routes from './routes/Routes';
import Loading from './components/loading/Loading';
import { Provider } from 'react-redux';
import initStore from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { clubDomain, gtmForClubEnv, GA, IS_PROD } from './data/Data';
import TagManager from 'react-gtm-module';
import ReactGA from 'react-ga';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faXmark, faCheckSquare, faChevronLeft, faChevronRight, faCropSimple, faTriangleExclamation, faImage, faImages, faCircleInfo, faPencilAlt, faPencil, faRedo, faSave, faSearch, faSpinner, faEnvelope, faGlobe, faRotateLeft, faPrint, faIdCard, faCircleQuestion, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import './App.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
library.add(faCheck, faXmark, faCheckSquare, faChevronLeft, faChevronRight, faCropSimple, faTriangleExclamation, faImage, faImages, faCircleInfo, faPencilAlt, faPencil, faRedo, faSave, faSearch, faSpinner, faSquare, faEnvelope, faGlobe, faRotateLeft, faPrint, faIdCard, faCircleQuestion, faCircleExclamation);
const {
  store,
  persistor
} = initStore();
// Google Tag Manager
const {
  hostname
} = window.location;
const club = clubDomain(hostname);
const tags = gtmForClubEnv(hostname);
for (const gtmId of tags) {
  TagManager.initialize({
    gtmId
  });
}

// Google Analytics
const ga = GA && GA[club] ? GA[club] : null;
if (ga && IS_PROD) {
  ReactGA.initialize(ga);
}
class App extends React.Component {
  constructor(props) {
    super(props);
    // $FlowFixMe
    _defineProperty(this, "app", void 0);
    this.app = /*#__PURE__*/React.createRef();
  }
  render() {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(Provider, {
        store: store,
        children: /*#__PURE__*/_jsx(PersistGate, {
          loading: /*#__PURE__*/_jsx(Loading, {}),
          persistor: persistor,
          children: /*#__PURE__*/_jsx(BrowserRouter, {
            children: /*#__PURE__*/_jsxs("div", {
              className: "App",
              ref: this.app,
              children: [/*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsx(Routes, {
                ...this.props
              }), /*#__PURE__*/_jsx(Footer, {}), /*#__PURE__*/_jsx(Cookies, {}), club === 'RACV' ? /*#__PURE__*/_jsx("script", {
                children: "_satellite.pageBottom();"
              }) : null]
            })
          })
        })
      })
    });
  }
}
_defineProperty(App, "defaultProps", {
  bugsnagClient: {
    notify: () => null
  },
  jest: false
});
export default App;